import React, { useEffect, useMemo, useState } from "react";
import "./order.css";
import Button from "../components/Button";
import TutorialModal from "../components/TutorialModal";
import { QRCodeCanvas } from "qrcode.react";
import {
    useGeneratePickupQRMutation,
    useGetActivePickupSessionQuery,
    useGetOrdersQuery,
} from "../store/api/orderApi";

const IssueOrdersPage = () => {
    const [qrData, setQrData] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    const { data: orders = [] } = useGetOrdersQuery(29);
    const { data } = useGetActivePickupSessionQuery();

    const [generateQr, { isLoading }] = useGeneratePickupQRMutation();

    const handleGenerateQr = async () => {
        try {
            const res = await generateQr().unwrap();

            if (res?.success) {
                setQrData(res.token);
                setIsOpen(true);
            }
        } catch (e) {
            alert("Ошибка генерации QR");
        }
    };

    useEffect(() => {
        if (data?.success) {
            setQrData(data.session.qr_token);
        }
    }, [data]);

    const groupedOrders = useMemo(() => {
        const filtered = orders.filter(
            (item) => item //Number(item.current_payment_status) === 2
        );

        const groups = {};

        filtered.forEach((item) => {
            const key = item.pickup_name || "Без ПВЗ";

            if (!groups[key]) groups[key] = [];

            groups[key].push(item);
        });

        return groups;
    }, [orders]);

    return (
        <div className="ordform-container">
            <h2 className="ordform-header">Выдача заказов</h2>

            <div className="ordform-space">
                <div className="personal-bottom">
                    <Button onClick={handleGenerateQr} loading={isLoading}>
                        Сгенерировать QR
                    </Button>
                </div>

                <div style={{ marginTop: 20 }}>
                    {Object.keys(groupedOrders).length === 0 && (
                        <div>Нет оплаченных заказов</div>
                    )}

                    {Object.entries(groupedOrders).map(([pickupName, items]) => (
                        <div key={pickupName} className="pickup-block">
                            <h3
                                style={{
                                    marginTop: 25,
                                    marginBottom: 15,
                                    color: "#e53935",
                                }}
                            >
                                {pickupName} ({items.length})
                            </h3>

                            <div className="orders-grid">
                                {items.map((order) => (
                                    <div key={order.guid} className="order-card">
                                        <div>
                                            <strong>Трек:</strong> {order.tracking_number}
                                        </div>

                                        <div>
                                            <strong>Страна:</strong> {order.country}
                                        </div>

                                        <div>
                                            <strong>Дата:</strong>{" "}
                                            {new Date(order.created_date).toLocaleString("ru-RU")}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <TutorialModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                title="QR для выдачи"
            >
                {qrData && (
                    <div style={{ textAlign: "center" }}>
                        <QRCodeCanvas
                            value={qrData}
                            size={300}
                            level="H"
                        />
                    </div>
                )}
            </TutorialModal>
        </div>
    );
};

export default IssueOrdersPage;